<template>
    <b-container fluid class="px-0">
        <b-overlay :show="progressing" class="h-100" rounded="sm">
            <b-btn @click="playSound" class="invisible position-absolute" ref="soundButton">
                sound
            </b-btn>
            <div class="relative" style="height: 85vh;">
                <b-row class="mb-4 align-items-center justify-content-between">
                    
                    
                    <b-col v-if="kdsList.length > 1" cols="12" md="3" class="mb-3 mb-md-0">
                        <div>
                            <b-input-group>
                                <template v-slot:prepend>
                                    <b-btn style="cursor:default;" class="font-weight-bold">Display</b-btn>
                                </template>
                                <b-form-select v-model="Filter_KDS" :options="kdsList" @change="filterByKds"></b-form-select>
                            </b-input-group>
                        </div>
                    </b-col>
                    <b-col cols="12" md="3" class="text-left text-md-right">
                        <b-button-group>
                            <b-button
                                    :class="reportType === 'open' ? 'activeBtn' : 'deactiveBtn'"
                                    @click="changeTicketType('open')"
                            >Open
<!--                                ({{getOpenCount}})-->
                            </b-button>
                            <b-button
                                    :class="reportType === 'proceed' ? 'activeBtn' : 'deactiveBtn'"
                                    @click="changeTicketType('proceed')"
                            >Prepared(READY)
<!--                                ({{getProceedCount}})-->
                            </b-button>
                            <b-button
                                    :class="reportType === 'fullyServed' ? 'activeBtn' : 'deactiveBtn'"
                                    @click="changeTicketType('fullyServed')"
                            >Fully Served
<!--                                ({{getProceedCount}})-->
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
                
                <b-row v-if="reportType === 'open'">
                    <template v-for="item in getOpenItems">
                        <b-col v-if="getFoodsByKds(item.Items)" class="mb-3"  cols="12" sm="6" md="4" lg="3">
                            <ticket-item :value="item" ticket-type="open" :currentKDS="Filter_KDS" :kds="selectedKds" :kdsList="kdsList"
                             :order-id="item.OrderID" @refresh="refreshReport" @refreshOneItemOnly="refreshOneItemOnly"/>
                        </b-col>
                    </template>
                </b-row>

                <b-row v-else-if="reportType === 'proceed' || reportType === 'fullyServed'">
                    <template v-for="item in getProceed">
                        <b-col v-if="getFoodsByKds(item.Items.RestaurantOrderDetails)" class="mb-3" cols="12" sm="6" md="4" lg="3">
                            <ticket-item :value="item" ticket-type="complete" :currentKDS="Filter_KDS" :kds="selectedKds" :kdsList="kdsList" 
                            :order-id="item.OrderID" @refresh="refreshReport" @refreshOneItemOnly="refreshOneItemOnly"/>
                        </b-col>
                    </template>
                </b-row>
                <b-row style="position:absolute ;bottom:0">
                    <b-col cols="12" md="3">
                        <b-pagination
                            v-if="reportType === 'open' "
                            v-model="pageNumberOpen"
                            :total-rows="totalOpen"
                            :per-page="perPage"
                            @change="changeOpenPagination"
                            class="my-3"
                        ></b-pagination>
                        <b-pagination
                            v-else-if="reportType === 'proceed'"
                            v-model="pageNumberProceed"
                            :total-rows="totalProceed"
                            :per-page="perPage"
                            @change="changeProceedPagination"
                            class="my-3"
                        ></b-pagination>
                        <b-pagination
                            v-else-if="reportType === 'fullyServed'"
                            v-model="pageNumberFullyServed"
                            :total-rows="totalFullyServed"
                            :per-page="perPage"
                            @change="changeFullyServedPagination"
                            class="my-3"
                        ></b-pagination>
                    </b-col>
                </b-row>

            </div>
        </b-overlay>
    </b-container>
</template>

<script>
    import TicketItem from "./component/ticketItem";
    import config from 'SrcConfig'
    import firebase from "firebase/compat";
    import '@firebase/messaging'
    export default {
        name: "index",
        components: {TicketItem},
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    //get clientId
                    if (newVal) {
                        this.progressing = true
                        Promise.all([
                            this.GetRestaurantKDSs(),
                        ]).then(res => {
                            for(let i=0; i<1000000; i++)
                            {
                                window.clearInterval(i);
                            }
                            this.refreshReport()
                            setInterval(() => {
                                this.refreshReport()
                            },this.intervalTime)
                        })
                    }
                },
                immediate: true
            }
        },
        beforeDestroy() {
            if(!window.location.pathname.includes('createOrder')){
                this.exitFullscreen()
            }
            //Delete setInterval when the component is lost
            for(let i=0; i<1000000; i++)
            {
                window.clearInterval(i);
            }
            clearInterval(this.beepInterval)
        },
        mounted() {
            this.enterFullscreen()
            const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null
            if (messaging) {
                messaging.onMessage((payload) => {
                    if (payload.data.type) {
                        if(payload.data.type == "createOrder"){
                            this.soundStatus()
                            this.refreshReport()

                        }
                        if (this.reportType === 'open') {
                            if (this.pageNumberOpen !== 1) {
                                this.$showInfo('new order has come')
                            }
                        } else {
                            if (this.pageNumberProceed !== 1) {
                                this.$showInfo('new order has come')
                            }
                        }
                    }
                })
            }
        },
        data () {
            return {
                kdsList: [],
                selectedKds: null,
                Filter_KDS: -1,
                Serve_Type: 'ToServe',
                pageNumberOpen: 1,
                pageNumberProceed: 1,
                pageNumberFullyServed: 1,
                filter: {
                    btn: [
                        {text: 'Pickup', value: 1, selected: false},
                        {text: 'Delivery', value: 2, selected: false},
                        {text: 'Dine in', value: 4, selected: false},
                    ]
                },
                opens: [],
                proceed: [],
                reportType: 'open',
                mode: 'all',
                progressing: false,
                perPage: 8,
                soundurl : config.redirectToHome + '/images/TOGOalarm.wav',
                totalOpen: 0,
                totalProceed: 0,
                intervalTime: localStorage.getItem('notifStatus') !== 'granted' ? 30000 : 180000,
                beepInterval:null,
                beepIntervalValue:10000,
           
            }
        },
        computed: {
            getOpenItems () {
                const items = this.opens
                return items
              // if (this.mode === 'all') {
              //     const items = this.opens.slice(
              //             (this.pageNumberOpen - 1) * this.perPage,
              //             this.pageNumberOpen * this.perPage
              //     )
              //     return items
              // } else if (this.mode === 'pickup') {
              //     const items = this.opens.filter(item => item.OrderTypeID === 1).slice(
              //             (this.pageNumberOpen - 1) * this.perPage,
              //             this.pageNumberOpen * this.perPage
              //     )
              //     return items
              // } else if (this.mode === 'delivery') {
              //     const items = this.opens.filter(item => item.OrderTypeID === 3).slice(
              //             (this.pageNumberOpen - 1) * this.perPage,
              //             this.pageNumberOpen * this.perPage
              //     )
              //     return items
              // } else if (this.mode === 'dinein') {
              //     const items = this.opens.filter(item => item.OrderTypeID === 2).slice(
              //             (this.pageNumberOpen - 1) * this.perPage,
              //             this.pageNumberOpen * this.perPage
              //     )
              //     return items
              // }
          },
            getOpenCount () {
                if (this.mode === 'all') {
                    return this.opens.length
                } else if (this.mode === 'pickup') {
                    return this.opens.filter(item => item.OrderTypeID === 1).length
                } else if (this.mode === 'delivery') {
                    return this.opens.filter(item => item.OrderTypeID === 3).length
                } else if (this.mode === 'dinein') {
                    return this.opens.filter(item => item.OrderTypeID === 2).length
                }
            },
            getProceed () {
              if (this.mode === 'all') {
                  return this.proceed
              } else if (this.mode === 'pickup') {
                  return this.proceed.filter(item => item.OrderTypeID === 1)
              } else if (this.mode === 'delivery') {
                  return this.proceed.filter(item => item.OrderTypeID === 3)
              } else if (this.mode === 'dinein') {
                  return this.proceed.filter(item => item.OrderTypeID === 2)
              }
          },
            getProceedCount () {
                if (this.mode === 'all') {
                    return this.proceed.length
                } else if (this.mode === 'pickup') {
                    return this.proceed.filter(item => item.OrderTypeID === 1).length
                } else if (this.mode === 'delivery') {
                    return this.proceed.filter(item => item.OrderTypeID === 3).length
                } else if (this.mode === 'dinein') {
                    return this.proceed.filter(item => item.OrderTypeID === 2).length
                }
            },
            
        },
        methods: {
            enterFullscreen() {
                const el = document.documentElement;
                if (el.requestFullscreen) {
                    el.requestFullscreen().catch(err => {
                    // Browser blocked it (e.g., page loaded fresh with no prior gesture)
                    console.warn('Fullscreen request blocked:', err.message);
                });
                }
            },
            exitFullscreen() {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                }
            },
            refreshOneItemOnly(selectedOrderID){
                if(this.reportType === "proceed"){
                    let index = this.proceed.findIndex(item => item.OrderID === selectedOrderID)
                    if (index !== -1) {
                        if(this.proceed[index].OrderStatusID == 1){
                            this.proceed[index].OrderStatusID = 2
                        }else{
                            this.proceed.splice(index, 1)
                            //this.refreshReport()
                        }
                    }

                }else{
                    let index = this.opens.findIndex(item => item.OrderID === selectedOrderID)
                    if (index !== -1) {
                        if(this.opens[index].OrderStatusID == 1){
                            this.opens[index].OrderStatusID = 2
                            this.opens[index].TicketTabAcknowledged = true
                        }else{
                            this.opens.splice(index, 1)
                            //this.refreshReport()
                        }
                    }

                }
            },
            getFoodsByKds (items) {
                if (!this.selectedKds) {
                    return true
                } else {
                    return !!items.filter(food => food.KDSid === this.selectedKds).length
                }
            },
            createFilter () {
                const obj = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    MenutypeID: -1,
                    IsLive: 1,
                    Filter_OrderStatus: 3,
                    Search: '',
                    Sort: '',
                    Filter_ServerName: -1,
                    Filter_KDS: this.Filter_KDS,
                    Serve_Type: this.Serve_Type,
                    BlockSize: 8,
                    startIndex: this.pageNumberOpen
                }
                // FullyServed
                return obj
            },
            createFilterProceed () {
                const obj = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    MenutypeID: -1,
                    IsLive: 1,
                    Filter_OrderStatus: -1,
                    Search: '',
                    Sort: '',
                    Filter_ServerName: -1,
                    Filter_KDS: this.Filter_KDS,
                    Serve_Type: this.Serve_Type,
                    BlockSize: 8,
                    startIndex: this.pageNumberProceed,
                }
                // FullyServed
                return obj
            },
            createFilterFullyServed () {
                const obj = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    MenutypeID: -1,
                    IsLive: 1,
                    Filter_OrderStatus: 4,
                    Search: '',
                    Sort: '',
                    Filter_ServerName: -1,
                    Filter_KDS: this.Filter_KDS,
                    Serve_Type: "FullyServed",
                    BlockSize: 8,
                    startIndex: this.pageNumberFullyServed,
                }
                return obj
            },

            filterTicket (Serve_Type) {
                this.Serve_Type = Serve_Type
                for(let i=0; i<1000000; i++) {
                    window.clearInterval(i)
                }
                this.refreshReport()
                setInterval(() => {
                    this.refreshReport()
                },this.intervalTime)
            },
            filterByKds () {
                for(let i=0; i<1000000; i++) {
                    window.clearInterval(i)
                }
                this.pageNumberOpen = 1
                this.pageNumberProceed = 1
                this.pageNumberFullyServed = 1
                this.refreshReport()
                setInterval(() => {
                    this.refreshReport()
                },this.intervalTime)
            },
            changeTicketType (ticketType) {
                this.reportType = ticketType
                for(let i=0; i<1000000; i++) {
                    window.clearInterval(i)
                }
                this.refreshReport()
                setInterval(() => {
                    this.refreshReport()
                },this.intervalTime)
            },

            getReportOpenTicket () {
                return this.$api.getRestaurant.GetRestaurantOpenTickets(this.createFilter()).then(res => {
                    if (res.success) {
                        let opens = res.results
                        if (opens.length) {
                            this.totalOpen = opens[0].Total_Record
                        } else {
                            this.totalOpen = 0
                        }
                        opens.forEach(item => {
                            item.ElapseItemTimes = item.Items.map(ch => {
                                if (ch.OrderStatus === 2) return ch.ElapsedTime
                                else return -1
                            })
                            item.MaxElapse = Math.max(...item.ElapseItemTimes)
                            item.ApproximateElapse = Math.floor(item.MaxElapse / 10)
                            item.noConfirmed = item.Items.every(ch => ch.OrderStatus === 1) ? true : false
                            item.playSoundPickupDelivery = item.OrderTypeID !== 2 && item.Items.find(ch => ch.OrderStatus === 2) ? true : false
                            item.playSoundDineIn = item.OrderTypeID === 2 &&  item.Items.find(ch => ch.OrderStatus === 2) ? true : false
                        })
                        const notConfirmed = opens.filter(item => item.noConfirmed)
                        const confirmed = opens.filter(item => !item.noConfirmed)
                        this.opens = [...confirmed, ...notConfirmed].sort((a,b) => {
                            return b.ApproximateElapse - a.ApproximateElapse
                        })
                        if (this.reportType === 'open') {
                            this.soundStatus(this.opens)
                        }
                    } else {
                        this.$showError(res.message)
                    }
                }).catch((error) => {
                    console.log("error: ",error)
                })
            },

            GetRestaurantProcessedTickets () {
                
                return this.$api.getRestaurant.GetRestaurantProcessedTickets(this.createFilterProceed()).then(res => {
                    if (res.success) {
                        let proceed = res.results
                        if (proceed.length) {
                            this.totalProceed = proceed[0].Total_Record
                        } else {
                            this.totalProceed = 0
                        }

                        proceed.forEach(item => {
                            item.ElapseItemTimes = item.Items.map(ch => {
                                if (item.OrderStatusID === 4) {
                                    return -2
                                } else {
                                    if (ch.OrderStatus === 3) return ch.ElapsedTime
                                    else return -1
                                }
                            })
                            item.MaxElapse = Math.max(...item.ElapseItemTimes)
                            item.ApproximateElapse = item.MaxElapse >= 0 ? Math.floor(item.MaxElapse / 10) : item.MaxElapse
                            item.playSoundPickupDelivery = item.OrderTypeID !== 1 && item.Items.find(ch => ch.OrderStatus === 3) ? true : false
                            item.playSoundDineIn = item.OrderTypeID === 1 &&  item.Items.find(ch => ch.OrderStatus === 3) ? true : false
                        })
                        this.proceed = proceed.sort((a,b) => {
                            return b.ApproximateElapse - a.ApproximateElapse
                        })
                        if (this.reportType !== 'open') {
                            this.soundStatus(this.proceed)
                        }
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {})
            },

            GetRestaurantFullyServedTickets () {
                return this.$api.getRestaurant.GetRestaurantProcessedTickets(this.createFilterFullyServed()).then(res => {
                    if (res.success) {
                        let fullyServed = res.results
                        if (fullyServed.length) {
                            this.totalFullyServed = fullyServed[0].Total_Record
                        } else {
                            this.totalFullyServed = 0
                        }

                        fullyServed.forEach(item => {
                            item.ElapseItemTimes = item.Items.map(ch => {
                                if (item.OrderStatusID === 4) {
                                    return -2
                                } else {
                                    if (ch.OrderStatus === 3) return ch.ElapsedTime
                                    else return -1
                                }
                            })
                            item.MaxElapse = Math.max(...item.ElapseItemTimes)
                            item.ApproximateElapse = item.MaxElapse >= 0 ? Math.floor(item.MaxElapse / 10) : item.MaxElapse
                            item.playSoundPickupDelivery = item.OrderTypeID !== 1 && item.Items.find(ch => ch.OrderStatus === 3) ? true : false
                            item.playSoundDineIn = item.OrderTypeID === 1 &&  item.Items.find(ch => ch.OrderStatus === 3) ? true : false
                        })
                        this.proceed = fullyServed.sort((a,b) => {
                            return b.ApproximateElapse - a.ApproximateElapse
                        })
                        if (this.reportType !== 'open') {
                            this.soundStatus(this.fullyServed)
                        }
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {})
            },

            refreshReport () {
                this.progressing = true
                if (this.reportType === 'open') {
                    this.getReportOpenTicket().then(() => {
                        this.progressing = false
                    })
                } else if(this.reportType === 'proceed') {
                    this.GetRestaurantProcessedTickets().then(() => {
                        this.progressing = false
                    })
                } else if(this.reportType === 'fullyServed') {
                    this.GetRestaurantFullyServedTickets().then(() => {
                        this.progressing = false
                    })
                }
                // Promise.all([
                //     this.GetRestaurantProcessedTickets()
                // ]).then(res => {
                //     this.progressing = false
                // })
            },
            changeOpenPagination (page) {
                this.pageNumberOpen = page
                for(let i=0; i<1000000; i++) {
                    window.clearInterval(i)
                }
                this.refreshReport()
                setInterval(() => {
                    this.refreshReport()
                },this.intervalTime)
               
            },
            changeProceedPagination (page) {
                this.pageNumberProceed = page
                for(let i=0; i<1000000; i++) {
                    window.clearInterval(i)
                }
                this.refreshReport()
                setInterval(() => {
                    this.refreshReport()
                },this.intervalTime)
            },
            
            changeFullyServedPagination (page) {
                this.pageNumberFullyServed = page
                for(let i=0; i<1000000; i++) {
                    window.clearInterval(i)
                }
                this.refreshReport()
                setInterval(() => {
                    this.refreshReport()
                },this.intervalTime)
            },
            GetRestaurantKDSs () {
                let object = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                }
                return this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
                    if (res.success) {
                        res.results.RestaurantKDS.forEach(item => {
                            item.value = item.KDSID
                            item.text = item.KDS
                        })
                        const list = res.results.RestaurantKDS
                        if (list.length === 1) {
                            this.Filter_KDS = res.results.RestaurantKDS[0].KDSID
                            this.kdsList = res.results.RestaurantKDS
                        } else {
                            this.Filter_KDS = -1
                            this.kdsList = [{value: -1, text: 'All'}].concat(res.results.RestaurantKDS)
                        }
                    }
                })
            },
            
            soundStatus (items) {
                   
                let model= {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    IsLive: 1,
                    Filter_OrderStatus: 3,
                    Search:'',
                    Sort:'',
                    Filter_ServerName: -1,
                    Filter_GeneralOrderStatus:"",
                    Filter_KDS: this.Filter_KDS
                }
                this.$api.getRestaurant.GetDashBoardRestaurantOrdersBeepTicket(model).then(res=>{
                    
                    if(res.success && !res.TicketTabAcknowledged){
                        this.startSoundInterval()
                    }else if(res.success && res.TicketTabAcknowledged){
                        this.stopSoundInterval()
                    
                    }else if(!res.success){
                        this.$showError("There was an issue with sound notification!!!")
                    }
                    
                    
                    

                })
            },
            stopSoundInterval(){
                if(this.beepInterval){
                    clearInterval(this.beepInterval)
                }
            },
            startSoundInterval(){
                        this.stopSoundInterval()
                        this.playSound()
                        this.beepInterval = setInterval(() => {
                            this.playSound()
                        }, this.beepIntervalValue);
                        return;
            },
            playSound () {
                var audio = new Audio(this.soundurl)
                audio.play()
            }
        }
    }
</script>

<style scoped>
    .sticky-footer{
        position: sticky;
        top: 55px;
        z-index: 950;
    }
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
</style>
